import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix for marker icons in React Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Approximate coordinates for IT parks in Pune
const itParks = [
  { name: "Cybercity Magarpatta", coords: [18.5089, 73.9344] },
  { name: "EON Free Zone", coords: [18.5515, 73.9417] },
  { name: "World Trade Center", coords: [18.5528, 73.9353] },
  { name: "ICC Towers", coords: [18.5287, 73.8413] },
  { name: "Rajiv Gandhi Infotech Park – Phase 1", coords: [18.5944, 73.7072] },
  { name: "Rajiv Gandhi Infotech Park – Phase 2", coords: [18.5962, 73.7164] },
  { name: "Rajiv Gandhi Infotech Park – Phase 3", coords: [18.5880, 73.7055] },
  { name: "Quadron Business Park", coords: [18.5916, 73.7389] },
  { name: "Cerebrum IT Park", coords: [18.5514, 73.9221] },
  { name: "Vatika Business Centre", coords: [18.5542, 73.9284] },
  { name: "Nanospace IT Park", coords: [18.5961, 73.7330] },
  { name: "Giga Space", coords: [18.5643, 73.9135] },
  { name: "Muttha Tower", coords: [18.5293, 73.8352] },
  { name: "Prabhavee Tech Park", coords: [18.5674, 73.7699] },
  { name: "Weikfeld", coords: [18.5678, 73.9140] },
  { name: "SP Infocity", coords: [18.4962, 73.9085] },
  { name: "Business Bay", coords: [18.5315, 73.8481] },
  { name: "Commerce Zone", coords: [18.5318, 73.8514] },
];

const PuneItMap = () => {
  return (
    <MapContainer center={[18.5204, 73.8567]} zoom={12} scrollWheelZoom={true} className="leaflet-container">
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {itParks.map((park, index) => (
        <Marker key={index} position={park.coords}>
          <Popup>{park.name}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export default PuneItMap;
